import styled from 'styled-components'
import { colors } from '@/styles'

const SectionSeparator = styled.div`
  width: 50px;
  border-bottom: 1px solid ${colors.grey};
`

export default SectionSeparator
